import React, { useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import AppsIcon from "../../assets/apps_icon.svg";
import GroupsIcon from "../../assets/manage_members_icon.svg";
import InvitesIcon from "../../assets/manage_invitations_icon.svg";
import SubscriptionsIcon from "../../assets/subscriptions_icon.svg";
import SupportIcon from "../../assets/support_icon.svg";
import { CustomListItem } from "./ListItem";

const drawerWidth = 310;

const useStyles = makeStyles(() => ({
    icon: {
        width: "12px",
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: "border-box",
        },
    },
    drawerPaperProps: {
        overflow: "auto",
        backgroundColor: "#2173AD",
        color: "#fff",
    },
    upperList: {
        marginBottom: "20px",
    },
}));

const ImgIcon = ({ src }) => <img src={src} style={{ width: "25px" }} />;

const manageMenus = [
    {
        text: "Apps",
        icon: <ImgIcon src={AppsIcon} />,
        path: "/apps",
        menuId: 0,
        permission: { action: "view", view: "published_apps" },
    },
    {
        text: "Manage members",
        icon: <ImgIcon src={GroupsIcon} />,
        path: "/team_members",
        menuId: 1,
        permission: { action: "view", view: "members" },
    },

    {
        text: "Manage invitations",
        icon: <ImgIcon src={InvitesIcon} />,
        path: "/invitations",
        menuId: 2,
        permission: { action: "view", view: "invitations" },
    },
    {
        text: "Subscriptions & invoices",
        icon: <ImgIcon src={SubscriptionsIcon} />,
        path: "/subscriptions",
        menuId: 3,
        permission: { action: "view", view: "invoice" },
    },
    {
        text: "API Key",
        icon: <VpnKeyIcon />,
        path: "/api-key",
        menuId: 4,
        permission: { action: "view", view: "api_key" },
    },
    {
        text: "Support",
        icon: <ImgIcon src={SupportIcon} />,
        path: "/help",
        menuId: 5,
        permission: { action: "view", view: "published_apps" },
    },
];

const DEFAULT_MENU_ID = 0;

export const SideBar = () => {
    const history = useHistory();
    const classes = useStyles();

    const [selectedMenuId, selectMenu] = useState(DEFAULT_MENU_ID);

    return (
        <Drawer
            variant="permanent"
            className={classes.drawer}
            PaperProps={{
                sx: {
                    backgroundColor: "#2173AD",
                },
            }}
        >
            <Toolbar />
            <Box className={classes.drawerPaperProps}>
                <List>
                    {manageMenus.map((item) => (
                        <CustomListItem
                            key={item?.text}
                            item={item}
                            selectedMenuId={selectedMenuId}
                            listItemAction={() => {
                                if (item?.path === "/help")
                                    window?.open(
                                        "https://edia.atlassian.net/servicedesk/customer/portal/1",
                                        "_blank",
                                    );

                                selectMenu(item?.menuId);

                                history.push(item?.path);
                            }}
                        />
                    ))}
                </List>
            </Box>
        </Drawer>
    );
};
